import React, { useEffect, useState, useRef } from 'react'

// next components
import Head from 'next/head'

// third party components
import { useDispatch, useSelector } from 'react-redux'
import { getTimeDifference, isAvailableDate } from 'utils/helpers'
import { ExploreAPIData } from 'types/nft'

// custom functions
import { useViewport } from 'utils'

// components
import CollectionCard from 'components/Card/CollectionCard'
import ArtistLayout from 'components/Layout/ArtistLayout'
import MobileNFTFilter from 'components/Filter/MobileNFTFilter'
import EcosystemCard from 'components/Card/EcosystemCard'
import EcosystemSkeletonCard from 'components/Card/EcosystemSkeletonCard'
import LoadingComponent from 'pages/profile/LoadingComponent'
import HomeEditionCard from 'components/Card/HomeEditionCard'
import HomeNftCard from 'components/Card/HomeNFTCard'
import LiveAuctionCard from 'components/Card/LiveAuctionCard'
import NftSkeletonCard from 'components/Card/NftSkeletonCard'

// json
import TabList from 'assets/json/explore/tab-list.json'
import NFTSortList from 'assets/json/explore/nft-sort.json'
import CollectionSortList from 'assets/json/explore/collection-sort.json'
import EcosystemSortList from 'assets/json/explore/ecosystem-sort.json'
import CategoryList from 'assets/json/popular-category.json'
import AvailabilityList from 'assets/json/explore/availability.json'
import MediumList from 'assets/json/explore/medium.json'
import MarketList from 'assets/json/explore/market.json'

import FilterGreenIcon from 'assets/icons/filter-icon-green.svg?component'
// styles
import styles from './index.module.scss'

// apis
import ExploreAPI from 'apis/explore'
import ExplorePageTab from './ExplorePageTab'
import ExploreFilterTab from 'components/Tab/ExploreFilterTab'

let pageTitle = 'Explore'
let pageImageUrl = 'https://foster-marketplace-dev.s3.us-east-2.amazonaws.com/preview-image.webp'
let pageDescription = 'A boutique marketplace for indie-crafted art, bespoke apparel, and timeless collectibles.'

const Explore = () => {
  const dispatch = useDispatch()
  const [isMounted, setIsMounted] = useState(false)
  const availabilityFilter = useSelector<any>(state => state.availabilityFilter)
  const collectionCategory = useSelector<any>(state => state.collectionCategory)
  const artworkCategory = useSelector<any>(state => state.artworkCategory)
  const artworkSort = useSelector<any>(state => state.artworkSort)
  const exploreTab = useSelector<any>(state => state.exploreTab)
  const [tabList, setTabList] = useState<any>(TabList)
  const [nftList, setNftList] = useState<ExploreAPIData[]>([])
  const [collectionList, setCollectionList] = useState<any>([])
  const [ecosystemList, setEcosystemList] = useState<any>([])
  const [categoryList, setCategoryList] = useState<any>([])
  const [nftCurrentPage, setNftCurrentPage] = useState(0)
  const [collectionCurrentPage, setCollectionCurrentPage] = useState(0)
  const [ecosystemCurrentPage, setEcoSystemCurrentPage] = useState(0)

  const [currentPage, setCurrentPage] = useState(0)
  const [totalCount, setTotalCount] = useState(0)
  const [rowCount, setRowCount] = useState(12)
  const [isFetching, setIsFetching] = useState(false)
  const [isVisibleFetching, setIsVisibleFetching] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [totalArtworkResult, setTotalArtworkResult] = useState(0)
  const [totalCollectionResult, setTotalCollectionResult] = useState(0)
  const [totalEcosystemResult, setTotalEcosystemResult] = useState(0)

  const [sortData, setSortData] = useState(NFTSortList)
  const [selectedSort, setSelectedSort] = useState(NFTSortList[0])
  const [selectedAvailability, setSelectedAvailability] = useState<any>(AvailabilityList[4])
  const [selectedMedium, setSelectedMedium] = useState<any>(MediumList[4])
  const [selectedMarket, setSelectedMarket] = useState<any>(MarketList[2])
  const [searchKeyword, setSearchKeyword] = useState('')

  useEffect(() => {
    let array: any[] = []
    TabList.map(item => {
      let object: any = item
      if (item.id === exploreTab) {
        object.selected = true
      } else {
        object.selected = false
      }
      array.push(object)
    })
    setTabList(array)

    if (exploreTab === 2) setShowFilter(false)
  }, [exploreTab])

  const handleSelectedTab = item => {
    dispatch({ type: 'set', exploreTab: item.id })
  }

  useEffect(() => {
    setTimeout(() => {
      setIsMounted(true)
    }, 1000)
  }, [])

  useEffect(() => {
    window.scrollTo({
      top: 0,
    })

    setIsMounted(false)
    setIsFetching(false)
    setIsVisibleFetching(true)

    setTimeout(() => {
      setIsMounted(true)
    }, 2000)
    let availability = selectedAvailability
    if (availabilityFilter === 0) {
      availability = AvailabilityList[0]
      setSelectedAvailability(availability)
    } else if (availabilityFilter === 1) {
      availability = AvailabilityList[1]
      setSelectedAvailability(availability)
    } else if (availabilityFilter === 2) {
      availability = AvailabilityList[2]
      setSelectedAvailability(availability)
    }

    switch (exploreTab) {
      case 0:
        setSortData(NFTSortList)
        if (artworkSort === 'popular') {
          setSelectedSort(NFTSortList[2])
        } else {
          setSelectedSort(NFTSortList[0])
        }
        setCurrentPage(nftCurrentPage)
        let artworkCatelist = []
        CategoryList.filter(category => category.query == artworkCategory).forEach(item => {
          let object: any = item
          object.checked = true
          artworkCatelist.push(object)
        })
        setCategoryList(artworkCatelist)
        getExploreNFTData(
          nftCurrentPage,
          artworkCatelist,
          availability,
          selectedMedium,
          selectedMarket,
          NFTSortList[0],
          rowCount,
          searchKeyword,
          true
        )
        break
      case 1:
        setSortData(CollectionSortList)
        let sortList
        setSelectedSort(CollectionSortList[1])
        sortList = CollectionSortList[1]
        setCurrentPage(collectionCurrentPage)
        let list = []
        CategoryList.filter(category => category.query == collectionCategory).forEach(item => {
          let object: any = item
          object.checked = true
          list.push(object)
        })
        setCategoryList(list)
        getExploreCollectionData(collectionCurrentPage, list, sortList, rowCount, searchKeyword, true)
        break
      case 2:
        setSortData(EcosystemSortList)
        setSelectedSort(EcosystemSortList[1])
        setCurrentPage(ecosystemCurrentPage)
        getExploreArtistData(ecosystemCurrentPage, EcosystemSortList[1], rowCount, searchKeyword, true)
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exploreTab, availabilityFilter])

  useEffect(() => {
    if (!isMounted) return

    window.scrollTo({
      top: 0,
    })

    switch (exploreTab) {
      case 0:
        setIsVisibleFetching(true)
        setNftList([])
        getExploreNFTData(
          0,
          categoryList,
          selectedAvailability,
          selectedMedium,
          selectedMarket,
          selectedSort,
          rowCount,
          searchKeyword,
          true
        )
        break
      case 1:
        // setIsVisibleFetching(true)
        // setCollectionList([])
        getExploreCollectionData(0, categoryList, selectedSort, rowCount, searchKeyword, true)
        break
      case 2:
        getExploreArtistData(ecosystemCurrentPage, selectedSort, rowCount, searchKeyword, true)
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAvailability, selectedMedium, selectedMarket, selectedSort, searchKeyword])

  const [openMobileFilter, setOpenMobileFilter] = useState(false)
  let stackNftList = []

  const getExploreNFTData = async (
    curPage,
    categoryList,
    availability,
    medium,
    market,
    sort,
    count,
    searchWord,
    reset = false
  ) => {
    let categoryLabel = []
    categoryList.map(category => {
      if (category.checked === true) {
        categoryLabel.push(category.query)
      }
    })
    let page = curPage
    if (reset === true) {
      page = 0
    }
    let isPrint = false
    if (availability.value === 'timed' || availability.value === 'fixed' || availability.value === 'editions')
      isPrint = true

    ExploreAPI.getExploreNFT({
      categories: categoryLabel.length === 0 ? null : categoryLabel,
      availability: availability.value,
      medium: medium.value,
      market: market.value,
      sort: sort.value,
      page: page + 1,
      per_page: count,
      search: searchWord,
    }).then(
      response => {
        setTotalArtworkResult(response.count)

        setIsFetching(false)
        if (response.nfts.length === 0) {
          setIsVisibleFetching(false)
          return
        }

        let nfts = []
        if (response.nfts.length === rowCount) setIsVisibleFetching(true)
        else setIsVisibleFetching(false)

        if (availability.value === 'timed') {
          response.nfts.forEach(nft => {
            if (isAvailableAuctionCard(nft)) {
              nfts.push({
                token_id: nft.token_id,
                asset_url: nft.asset_url,
                nft_name: nft.nft_name,
                asset_type: nft.asset_type,
                cover_image_url: nft.cover_image_url,
                artist_username: nft.artist_username,
                artist_profile_picture: nft.artist_profile_picture,
                current_supply: nft.current_supply,
                url: `/nft/${nft.token_id}`,
                price: nft.list_price,
                current_bid: nft.current_bid,
                master_edition: nft.master_edition,
                parent_nft: nft.parent_nft,
                max_supply: nft.max_supply,
                list_price: nft.list_price,
                start_time: nft.start_time,
                end_time: nft.end_time,
                reserve_price: nft.reserve_price,
                collection_name: nft.collection_name,
              })
            }
          })
        } else if (availability.value === 'editions') {
          let liveEditions = response.nfts.filter(nft => {
            if (nft.master_edition?.endTime !== null) {
              let difference = getTimeDifference(nft.master_edition?.endTime)
              if (difference < 0) return false
            }
            return true
          })

          if (liveEditions.length > 0) {
            nfts = liveEditions.map(nft => {
              return {
                token_id: nft.token_id,
                asset_url: nft.asset_url,
                nft_name: nft.nft_name,
                asset_type: nft.asset_type,
                cover_image_url: nft.cover_image_url,
                artist_username: nft.artist_username,
                artist_profile_picture: nft.artist_profile_picture,
                current_supply: nft.current_supply,
                url: `/nft/${nft.token_id}`,
                master_edition: nft.master_edition,
                parent_nft: nft.parent_nft,
                max_supply: nft.max_supply,
                current_bid: nft.current_bid,
                list_price: nft.list_price,
                price: nft.master_edition.price,
                start_time: nft.start_time,
                end_time: nft.master_edition?.endTime,
                reserve_price: nft.reserve_price,
                collection_name: nft.collection_name,
              }
            })
          } else {
            setIsVisibleFetching(false)
          }
        } else {
          nfts = response.nfts.map(nft => {
            return {
              token_id: nft.token_id,
              asset_url: nft.asset_url,
              nft_name: nft.nft_name,
              asset_type: nft.asset_type,
              cover_image_url: nft.cover_image_url,
              artist_username: nft.artist_username,
              artist_profile_picture: nft.artist_profile_picture,
              current_supply: nft.current_supply,
              url: `/nft/${nft.token_id}`,
              price: nft.list_price,
              master_edition: nft.master_edition,
              parent_nft: nft.parent_nft,
              max_supply: nft.max_supply,
              current_bid: nft.current_bid,
              list_price: nft.list_price,
              start_time: nft.master_edition ? nft.master_edition.startTime : nft.start_time,
              end_time: nft.master_edition ? nft.master_edition.endTime : nft.end_time,
              reserve_price: nft.reserve_price,
              collection_name: nft.collection_name,
            }
          })
        }

        setCurrentPage(curPage)
        setNftCurrentPage(curPage)
        setTotalCount(count * curPage + response.nfts.length)

        if (response.nfts.length < rowCount) {
          if (reset === true) setNftList([...nfts])
          else setNftList([...nftList, ...nfts])
        } else if (nfts.length < 4) {
          stackNftList = [...stackNftList, ...nfts]
          if (stackNftList.length >= 4) {
            if (reset === true) setNftList([...stackNftList])
            else setNftList([...nftList, ...stackNftList])
            stackNftList = []
          } else {
            loadMorePage(curPage + 1)
          }
        } else {
          if (reset === true) setNftList([...nfts])
          else setNftList([...nftList, ...nfts])
        }
      },
      error => {
        // dispatch({ type: 'set', isLoading: false })
        setIsFetching(false)
        setIsVisibleFetching(false)
      }
    )
  }

  const getExploreCollectionData = async (curPage, categoryList, sort, count, searchWord, reset = false) => {
    let categoryLabel = []
    categoryList.map(category => {
      if (category.checked === true) {
        categoryLabel.push(category.query)
      }
    })

    let page = curPage
    if (reset === true) {
      page = 0
    }

    ExploreAPI.getExploreCollection({
      categories: categoryLabel.length === 0 ? null : categoryLabel,
      availability: null,
      medium: null,
      market: null,
      sort: sort.value,
      page: page + 1,
      per_page: count,
      search: searchWord,
    }).then(
      response => {
        setTotalCollectionResult(response.count)

        setIsFetching(false)

        if (response.collections.length === 0) return

        if (response.collections.length === rowCount) setIsVisibleFetching(true)
        else setIsVisibleFetching(false)
        const collections = response.collections.map(nft => {
          return {
            collectionId: nft.collection_id,
            image: nft.cover_image,
            collectionName: nft.collection_name,
            artistName: nft.artist_username,
            artist_profile_picture: nft.artist_profile_picture,
            number_in_collections: nft.number_in_collections,
            url: `/collection?id=${nft.collection_id}`,
            mintAddress: nft.artist_id,
          }
        })
        setCurrentPage(curPage)
        setCollectionCurrentPage(curPage)
        setTotalCount(count * curPage + collections.length)
        if (reset === true) setCollectionList([...collections])
        else setCollectionList([...collectionList, ...collections])
      },
      error => {
        setIsFetching(false)
        setIsVisibleFetching(false)
      }
    )
  }

  const getExploreArtistData = async (curPage, sort, count, searchWord, reset = false) => {
    let page = curPage
    if (reset === true) {
      page = 0
    }

    ExploreAPI.getExploreArtists({
      categories: null,
      availability: null,
      medium: null,
      market: null,
      sort: sort.value,
      page: page + 1,
      per_page: count,
      search: searchWord,
    }).then(
      response => {
        setTotalEcosystemResult(response.count)

        setIsFetching(false)
        if (response.artists.length === rowCount) setIsVisibleFetching(true)
        else setIsVisibleFetching(false)

        setCurrentPage(curPage)
        setEcoSystemCurrentPage(curPage)
        setTotalCount(count * curPage + response.artists.length)

        if (reset === true) setEcosystemList([...response.artists])
        else setEcosystemList([...ecosystemList, ...response.artists])
      },
      error => {
        setIsFetching(false)
        setIsVisibleFetching(false)
      }
    )
  }

  const handleNextPage = () => {
    if (exploreTab === 0 && nftList.length === 0) return
    if (exploreTab === 1 && collectionList.length === 0) return
    if (exploreTab === 2 && ecosystemList.length === 0) return

    if (totalCount < (currentPage + 1) * rowCount) return
    const nextPage = currentPage + 1

    if (exploreTab === 0)
      getExploreNFTData(
        nextPage,
        categoryList,
        selectedAvailability,
        selectedMedium,
        selectedMarket,
        selectedSort,
        rowCount,
        searchKeyword
      )
    else if (exploreTab === 1) getExploreCollectionData(nextPage, categoryList, selectedSort, rowCount, searchKeyword)
    else if (exploreTab === 2) getExploreArtistData(nextPage, selectedSort, rowCount, searchKeyword)
  }

  const loadMorePage = nextPage => {
    if (exploreTab === 0)
      getExploreNFTData(
        nextPage,
        categoryList,
        selectedAvailability,
        selectedMedium,
        selectedMarket,
        selectedSort,
        rowCount,
        searchKeyword
      )
    else if (exploreTab === 1) getExploreCollectionData(nextPage, categoryList, selectedSort, rowCount, searchKeyword)
    else if (exploreTab === 2) getExploreArtistData(nextPage, selectedSort, rowCount, searchKeyword)
  }

  const selectCategory = categoryList => {
    window.scrollTo({
      top: 0,
    })

    setCategoryList(categoryList)

    if (exploreTab === 0)
      getExploreNFTData(
        currentPage,
        categoryList,
        selectedAvailability,
        selectedMedium,
        selectedMarket,
        selectedSort,
        rowCount,
        searchKeyword,
        true
      )
    else if (exploreTab === 1) {
      setCollectionList([])
      getExploreCollectionData(currentPage, categoryList, selectedSort, rowCount, searchKeyword, true)
    } else if (exploreTab === 2) getExploreArtistData(currentPage, selectedSort, rowCount, searchKeyword, true)
  }

  const onMobileFilter = async params => {
    let categoryList = params['category']
    let newCateList = JSON.parse(JSON.stringify(categoryList))
    setCategoryList(newCateList)

    if (exploreTab === 0) {
      let availability = params['availability']
      setSelectedAvailability(availability)

      let medium = params['medium']
      setSelectedMedium(medium)

      let market = params['market']
      setSelectedMarket(market)
      getExploreNFTData(
        currentPage,
        newCateList,
        availability,
        medium,
        market,
        selectedSort,
        rowCount,
        searchKeyword,
        true
      )
    } else if (exploreTab === 1) {
      getExploreCollectionData(currentPage, newCateList, selectedSort, rowCount, searchKeyword, true)
    } else {
      getExploreArtistData(currentPage, selectedSort, rowCount, searchKeyword, true)
    }
  }

  const isAvailableAuctionCard = nft => {
    let start_time = nft.start_time
    let end_time = nft.end_time
    if (start_time === null || end_time === null) return false
    if (getTimeDifference(end_time) < 0) return false
    if (isAvailableDate(start_time, end_time)) return true
    else return false
  }

  useEffect(() => {
    if (isFetching === true) {
      handleNextPage()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching])

  const sidebarRef = useRef<HTMLDivElement>(null)
  const [sidebarHeight, setSidebarHeight] = useState(0)
  const [viewportHeight, setViewportHeight] = useState(0)
  const [isInitialized, setIsInitialized] = useState(false)
  const prevY = useRef(0)
  const headerHeight = 192

  const updateSidebarHeight = () => {
    if (sidebarRef.current) {
      setSidebarHeight(sidebarRef.current.scrollHeight)
      setViewportHeight(window.innerHeight)
      setIsInitialized(true)
    }
  }

  useEffect(() => {
    setViewportHeight(window.innerHeight)
    updateSidebarHeight()
    window.addEventListener('resize', updateSidebarHeight)
    return () => window.removeEventListener('resize', updateSidebarHeight)
  }, [])

  useEffect(() => {
    if (!sidebarRef.current) return

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        setSidebarHeight(entry.contentRect.height)
        setViewportHeight(window.innerHeight)
      }
    })

    resizeObserver.observe(sidebarRef.current)

    return () => resizeObserver.disconnect()
  }, [sidebarRef])

  useEffect(() => {
    if (!isInitialized) return

    const handleScroll = () => {
      if (!sidebarRef.current) return

      const scrollY = window.scrollY
      const windowHeight = viewportHeight - headerHeight
      const sidebarOffset = sidebarHeight - windowHeight
      const containerRect = sidebarRef.current.getBoundingClientRect()
      let direction = scrollY > prevY.current ? 'down' : 'up'

      let offset = Math.min(prevY.current - scrollY, 20)

      if (sidebarHeight < windowHeight) {
        sidebarRef.current.style.top = `${headerHeight}px`
      } else {
        if (direction === 'up') {
          if (containerRect.top >= headerHeight - 20) {
            sidebarRef.current.style.top = `${headerHeight}px`
          } else {
            sidebarRef.current.style.top = `${containerRect.top + offset}px`
          }
        } else {
          if (containerRect.top * -1 >= sidebarOffset && scrollY > sidebarOffset) {
            sidebarRef.current.style.top = `-${sidebarOffset}px`
          } else {
            sidebarRef.current.style.top = `${containerRect.top + offset}px`
          }
        }
      }

      prevY.current = scrollY
    }

    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleScroll)
    handleScroll() // Initial check

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleScroll)
    }
  }, [headerHeight, sidebarHeight, isInitialized, viewportHeight])

  return (
    <div className="w-full g-container min-h-screen flex justify-center">
      <Head>
        <title>{pageTitle}</title>

        <meta name="description" content={pageDescription} />

        <meta name="og:title" content={pageTitle} />
        <meta name="og:description" content={pageDescription} />
        <meta name="og:image" content={pageImageUrl} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={pageImageUrl} />

        <link rel="icon" href="/logo.png" />
      </Head>
      <div className="w-full">
        <div className="lg:sticky lg:top-[80px] lg:z-[100]">
          <ExplorePageTab
            tabType={exploreTab}
            setTabType={tab => handleSelectedTab(tabList[tab])}
            selectedSort={selectedSort}
            sortList={exploreTab === 0 ? NFTSortList : exploreTab === 1 ? CollectionSortList : EcosystemSortList}
            handleSelectSort={sort => setSelectedSort(sort)}
            showFilter={showFilter}
            setShowFilter={setShowFilter}
            openMobileFilter={openMobileFilter}
            setOpenMobileFilter={setOpenMobileFilter}
            total={
              exploreTab === 0 ? totalArtworkResult : exploreTab === 1 ? totalCollectionResult : totalEcosystemResult
            }
          />
        </div>
        <div className="w-full flex">
          <div className="flex-1">
            <div className="w-full mt-[30px] lg:mt-[30px]">
              {exploreTab === 0 && nftList.length > 0 && (
                <div
                  className={`grid grid-cols-1 sm:grid-cols-2 ${
                    showFilter ? 'lg:grid-cols-3 2xl:grid-cols-4' : 'lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5'
                  } gap-[25px] lg:gap-[15px] 2xl:gap-[30px] mb-[100px]`}
                >
                  {nftList?.map((item, index) => {
                    return (
                      <div className="w-full" key={index}>
                        {selectedAvailability.value === 'timed' ? (
                          <LiveAuctionCard data={item} onClick={() => {}} setCardExpired={item => {}} />
                        ) : selectedAvailability.value === 'editions' ? (
                          <HomeEditionCard
                            data={{
                              tokenId: item.token_id,
                              nftName: item.nft_name,
                              artistUsername: item.artist_username,
                              artistProfilePicture: item.artist_profile_picture,
                              coverImageUrl: item.cover_image_url,
                              assetUrl: item.asset_url,
                              endTime: item.end_time,
                              startTime: item.start_time,
                              price: item.price,
                              currentSupply: item.current_supply,
                              maxSupply: item.max_supply,
                            }}
                            type={item.max_supply === null ? 'open' : 'limit'}
                            onClick={() => {}}
                          />
                        ) : selectedAvailability.value === 'all' ? (
                          item?.master_edition !== null && item?.master_edition !== undefined ? (
                            <HomeEditionCard
                              data={{
                                tokenId: item.token_id,
                                nftName: item.nft_name,
                                artistUsername: item.artist_username,
                                artistProfilePicture: item.artist_profile_picture,
                                coverImageUrl: item.cover_image_url,
                                assetUrl: item.asset_url,
                                endTime: item.end_time,
                                startTime: item.start_time,
                                price: item.master_edition.price,
                                currentSupply: item.current_supply,
                                maxSupply: item.max_supply,
                              }}
                              type={item.max_supply === null ? 'open' : 'limit'}
                              onClick={() => {}}
                            />
                          ) : isAvailableAuctionCard(item) ? (
                            <LiveAuctionCard data={item} onClick={() => {}} setCardExpired={item => {}} />
                          ) : !item.end_time && item.price ? (
                            <HomeNftCard
                              nftName={item.nft_name}
                              token_id={item.token_id}
                              artistName={item.artist_username}
                              artistImage={item.artist_profile_picture}
                              image={item.asset_url}
                              price={item.price}
                              assetType={item.asset_type}
                              coverImage={item.cover_image_url}
                              onClick={() => {}}
                              parentNft={item.parent_nft}
                              maxSupply={item.max_supply}
                            />
                          ) : (
                            <HomeNftCard
                              token_id={item.token_id}
                              image={item.asset_url}
                              nftName={item.nft_name}
                              artistImage={item.artist_profile_picture}
                              assetType={item.asset_type}
                              coverImage={item.cover_image_url}
                              artistName={item.artist_username}
                              onClick={() => {}}
                              price={item.price}
                              parentNft={item.parent_nft}
                              maxSupply={item.max_supply}
                            />
                          )
                        ) : !item.end_time && item.price ? (
                          <HomeNftCard
                            nftName={item.nft_name}
                            token_id={item.token_id}
                            artistName={item.artist_username}
                            artistImage={item.artist_profile_picture}
                            image={item.asset_url}
                            price={item.price}
                            assetType={item.asset_type}
                            coverImage={item.cover_image_url}
                            onClick={() => {}}
                            parentNft={item.parent_nft}
                            maxSupply={item.max_supply}
                          />
                        ) : (
                          <HomeNftCard
                            token_id={item.token_id}
                            image={item.asset_url}
                            nftName={item.nft_name}
                            artistImage={item.artist_profile_picture}
                            assetType={item.asset_type}
                            coverImage={item.cover_image_url}
                            artistName={item.artist_username}
                            onClick={() => {}}
                            price={item.price}
                            parentNft={item.parent_nft}
                            maxSupply={item.max_supply}
                          />
                        )}
                      </div>
                    )
                  })}
                </div>
              )}
              {exploreTab === 1 && collectionList.length > 0 && (
                <div
                  className={`grid grid-cols-1 sm:grid-cols-2 ${
                    showFilter ? 'lg:grid-cols-3 2xl:grid-cols-4' : 'lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5'
                  } gap-[25px] lg:gap-[15px] 2xl:gap-[30px] mb-[100px]`}
                >
                  {collectionList.map((item, index) => (
                    <div key={index}>
                      <CollectionCard
                        image={item.image}
                        nftName={item.collectionName}
                        artistName={item.artistName}
                        collectionId={item.collectionId}
                        unSave={() => {}}
                        isOwn={false}
                      />
                    </div>
                  ))}
                </div>
              )}
              {exploreTab === 2 && ecosystemList.length > 0 && (
                <div
                  className={`grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-[20px] lg:gap-[10px] xl:gap-[15px] 2xl:gap-[30px] mb-[100px]`}
                >
                  {ecosystemList.map((item, index) => (
                    <div key={index}>
                      <EcosystemCard data={item} />
                    </div>
                  ))}
                </div>
              )}
              {exploreTab === 0 && nftList.length === 0 ? (
                <div
                  className={`grid sm:grid-cols-2 ${
                    showFilter ? 'lg:grid-cols-3 2xl:grid-cols-4' : 'lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5'
                  } gap-[9px] lg:gap-[10px] xl:gap-[15px] 2xl:gap-[30px] mb-[100px]`}
                >
                  {Array.from({ length: 10 }).map((_, index) => (
                    <div key={index} className="w-full">
                      <NftSkeletonCard />
                    </div>
                  ))}
                </div>
              ) : exploreTab === 1 && collectionList.length === 0 ? (
                <div
                  className={`grid sm:grid-cols-2 ${
                    showFilter ? 'lg:grid-cols-3 2xl:grid-cols-4' : 'lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5'
                  } gap-[9px] lg:gap-[10px] xl:gap-[15px] 2xl:gap-[30px] mb-[100px]`}
                >
                  {Array.from({ length: 10 }).map((_, index) => (
                    <div key={index} className="w-full">
                      <NftSkeletonCard />
                    </div>
                  ))}
                </div>
              ) : exploreTab === 2 && ecosystemList.length === 0 ? (
                <div
                  className={`grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-[20px] lg:gap-[10px] xl:gap-[15px] 2xl:gap-[30px] mb-[100px]`}
                >
                  {Array.from({ length: 6 }).map((_, index) => (
                    <div key={index} className="w-full">
                      <EcosystemSkeletonCard />
                    </div>
                  ))}
                </div>
              ) : (
                isMounted &&
                isVisibleFetching && (
                  <LoadingComponent isFetching={isFetching} setIsFetching={setIsFetching} text="Loading" />
                )
              )}

              {!isVisibleFetching && isMounted && exploreTab === 0 && nftList.length === 0 && (
                <div className={styles.result}>No results found</div>
              )}
            </div>
          </div>
          {showFilter && (
            <div
              ref={sidebarRef}
              className="lg:block hidden w-[282px] ml-[37px] mt-[18px] lg:mt-[30px] sticky"
              style={{ height: 'fit-content' }}
            >
              <ExploreFilterTab
                exploreType={exploreTab}
                selectedAvailability={selectedAvailability}
                setSelectedAvailability={setSelectedAvailability}
                selectedMedium={selectedMedium}
                setSelectedMedium={setSelectedMedium}
                selectCategory={selectCategory}
                selectedMarket={selectedMarket}
                setSelectedMarket={setSelectedMarket}
                handleSearch={keyword => setSearchKeyword(keyword)}
                updateSidebarHeight={updateSidebarHeight}
              />
            </div>
          )}
        </div>
        <div className="flex lg:hidden w-full">
          {openMobileFilter && (
            <MobileNFTFilter
              exploreType={exploreTab}
              category={categoryList}
              availability={selectedAvailability}
              medium={selectedMedium}
              market={selectedMarket}
              onFilter={params => {
                onMobileFilter(params)
                setOpenMobileFilter(false)
              }}
              onClose={() => setOpenMobileFilter(false)}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Explore

const LayoutWrapper = ({ children }: { children }) => {
  const viewport = useViewport()
  const isMobile = viewport === 'xs' || viewport === 'sm' || viewport === 'md'

  return <ArtistLayout style={{ overflow: isMobile ? 'hidden' : 'visible' }}>{children}</ArtistLayout>
}

Explore.getLayout = function getLayout(page) {
  return <LayoutWrapper>{page}</LayoutWrapper>
}
